<template>
  <NaviTool :screenSize="screenSize" />
  <!-- Home Page
==========================================-->
  <HomeInfo :screenSize="screenSize" />

  <!-- BodorPlus Info
==========================================-->
  <BodorPlus />

  <!-- Area Page
==========================================-->
  <OurArea :langChange="langChange" />

  <!-- BodorMes Info
==========================================-->
  <BodorMes :screenSize="screenSize" />

  <!-- MesIncrease Section
==========================================-->
  <MesIncrease />

  <!-- BodorHub Section
==========================================-->
  <BodorHub />

  <!-- HubPartners Section
==========================================-->
  <HubPartners />

  <!-- BodorCAM Section
==========================================-->
  <BodorCam :screenSize="screenSize" />

  <!-- TechSupport Section
==========================================-->
  <!--   <TechSupport /> -->

  <!-- Contact Section
==========================================-->
  <ContactUs :screenSize="screenSize" />

  <PageFooter />

  <link rel="stylesheet" type="text/css" href="css/bootstrap.css" />
  <link rel="stylesheet" type="text/css" href="fonts/font-awesome/css/font-awesome.css" />

  <!-- Slider
================================================== -->
  <link href="css/owl.carousel.css" rel="stylesheet" media="screen" />
  <link href="css/owl.theme.css" rel="stylesheet" media="screen" />

  <!-- Stylesheet
================================================== -->
  <link rel="stylesheet" type="text/css" href="css/style.css" />
  <link rel="stylesheet" type="text/css" href="css/responsive.css" />
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import NaviTool from "./NaviTool.vue";
import HomeInfo from "./HomeInfo.vue";
import BodorPlus from "./BodorPlus.vue";
import OurArea from "./OurArea.vue";
import BodorMes from "./BodorMes.vue";
import MesIncrease from "./MesIncrease.vue";
import BodorHub from "./BodorHub.vue";
import HubPartners from "./HubPartners.vue";
import BodorCam from "./BodorCam.vue";
import ContactUs from "./ContactUs.vue";
import PageFooter from "@/components/PageFooter.vue";
import { throttle } from "@/utils/util.js";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

const route = useRoute();
const { t } = useI18n();
const i18n = useI18n();

/**
 * 主函数入口
 */
const langChange = ref("zhs");
init();

function init() {
  let loacl = localStorage.getItem("lang");
  langChange.value = loacl;
  if (route.query.lang == "en" && loacl != "en") {
    i18n.locale = "en";
    localStorage.setItem("lang", "en");
    location.reload();
  } else if (route.query.lang == "zh" && loacl != "zh") {
    i18n.locale = "zh";
    localStorage.setItem("lang", "zh");
    location.reload();
  }
}

// 响应式数据，用于存储屏幕大小分类
const screenSize = ref();

// 监听窗口大小变化的函数
function handleResize() {
  const width = window.innerWidth;
  // if (width < 600) {
  //   screenSize.value = "small";
  // } else if (width < 1200) {
  //   screenSize.value = "medium";
  // } else {
  //   screenSize.value = "large";
  // }
  screenSize.value = width;
}

// 使用throttle封装handleResize，并保存引用
const throttledResize = throttle(handleResize, 500);

onMounted(() => {
  $("a.page-scroll").click(function () {
    if (
      location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        $("html,body").animate(
          {
            scrollTop: target.offset().top - 40,
          },
          900
        );
        return false;
      }
    }
  });

  /*====================================
    Show Menu on Book
    ======================================*/
  $(window).bind("scroll", function () {
    var navHeight = $(window).height() - 250;
    if ($(window).scrollTop() > navHeight) {
      $(".navbar-default").addClass("on");
    } else {
      $(".navbar-default").removeClass("on");
    }
  });

  $("body").scrollspy({
    target: ".navbar-default",
    offset: 80,
  });

  $(document).ready(function () {
    $("#area").owlCarousel({
      navigation: false, // Show next and prev buttons
      slideSpeed: 300,
      paginationSpeed: 400,
      autoHeight: true,
      itemsCustom: [
        [0, 1],
        [450, 2],
        [600, 2],
        [700, 2],
        [1000, 4],
        [1200, 4],
        [1400, 4],
        [1600, 4],
      ],
    });

    $("#clients").owlCarousel({
      navigation: false, // Show next and prev buttons
      slideSpeed: 300,
      paginationSpeed: 400,
      autoHeight: true,
      itemsCustom: [
        [0, 1],
        [450, 2],
        [600, 2],
        [700, 2],
        [1000, 4],
        [1200, 5],
        [1400, 5],
        [1600, 5],
      ],
    });

    $("#testimonial").owlCarousel({
      navigation: false, // Show next and prev buttons
      slideSpeed: 300,
      paginationSpeed: 400,
      singleItem: true,
    });
  });

  window.addEventListener("resize", throttledResize);
  handleResize(); // 初始时立即检查
});

onUnmounted(() => {
  window.removeEventListener("resize", throttledResize);
});
</script>

<style>
.section-title.center .line {
  border-top: 4px solid rgb(255, 70, 16);
  height: 10px;
  width: 60px;
  text-align: center;
  margin: 0 auto;
  margin-top: 20px;
}

.section-title.center hr {
  border-top: 4px solid rgb(255, 70, 16);
  opacity: 0.34;
  width: 40px;
  text-align: center;
  margin-top: 10px;
  position: relative;
  left: 17%;
}

a {
  color: rgb(255, 70, 16);
}

a:hover,
a:focus {
  text-decoration: none;
  color: rgb(255, 70, 16);
}

.section-title hr {
  border-color: rgb(255, 70, 16);
  border-width: 4px;
  width: 60px;
  float: left;
  clear: both;
}
</style>
